import { NavLink } from 'react-router-dom'
import { cn } from '@/lib/utils'

interface SidebarNavItemProps {
	to: string
	label: string
	icon: React.ComponentType<{ className?: string }>
	onClick: () => void
}

export function SidebarNavItem({ to, label, icon: Icon, onClick }: SidebarNavItemProps) {
	return (
		<NavLink
			to={to}
			end={to === '/'}
			onClick={onClick}
			className={({ isActive }) => cn('group overflow-hidden rounded-xl border p-0.5 transition-colors', isActive ? 'border-primary' : 'border-border')}
		>
			{({ isActive }) => (
				<span
					className={cn(
						'flex items-center gap-2 overflow-hidden rounded-[10px] py-2 pl-1 pr-3.5 transition-colors',
						isActive ? 'bg-secondary bg-[linear-gradient(90deg,hsl(var(--primary)/0.12)_1.15%,hsl(var(--primary)/0)_82.95%)]' : 'bg-secondary',
					)}
				>
					<span
						aria-hidden
						className={cn(
							'h-4 w-0.5 shrink-0 rounded-full transition-[background-color,box-shadow]',
							isActive
								? 'bg-primary shadow-[0_0_12px_6px_hsl(var(--primary)/0.6)]'
								: 'bg-border group-hover:bg-primary group-hover:shadow-[0_0_8px_2px_hsl(var(--primary)/0.35)]',
						)}
					/>
					<Icon className={cn('h-6 w-6 shrink-0 transition-colors', isActive ? 'text-primary' : 'text-icon-muted group-hover:text-primary')} />
					<span className={cn('text-sm tracking-[-0.21px] transition-colors', isActive ? 'font-medium text-foreground' : 'font-normal text-muted-foreground')}>
						{label}
					</span>
				</span>
			)}
		</NavLink>
	)
}
